import React from 'react';

const PhotoUpload = ({ onPhotoUpload, onCameraCapture, onVideoRecord, isProcessing }) => {
  const fileInputRef = React.useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      onPhotoUpload(file);
    }
    event.target.value = null;
  };

  return (
    <div className="flex flex-col items-center p-8 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold text-gray-800 mb-6">Upload Your Photo</h2>
      <p className="text-gray-600 mb-6 text-center">
        Choose a clear, full-body photo for the best results.
      </p>
      
      <div className="flex flex-col space-y-4 w-full max-w-sm">
        <button
          onClick={() => fileInputRef.current.click()}
          disabled={isProcessing}
          className={`px-8 py-3 rounded-full text-lg font-semibold transition-colors duration-200 ${isProcessing ? 'bg-gray-400 text-gray-700 cursor-not-allowed' : 'bg-black text-white hover:bg-gray-800'}`}
        >
          Upload from My Folders
        </button>
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          accept="image/*,video/*"
          className="hidden"
        />
        <div className="relative flex items-center justify-center text-gray-400">
          <hr className="w-full border-t border-gray-300" />
          <span className="absolute bg-white px-2 text-sm font-medium">or</span>
        </div>
        <button
          onClick={onCameraCapture}
          disabled={isProcessing}
          className={`px-8 py-3 rounded-full text-lg font-semibold transition-colors duration-200 ${isProcessing ? 'bg-gray-400 text-gray-700 cursor-not-allowed' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}
        >
          Use My Camera Device
        </button>
        <button
          onClick={onVideoRecord}
          disabled={isProcessing}
          className={`px-8 py-3 rounded-full text-lg font-semibold transition-colors duration-200 ${isProcessing ? 'bg-gray-400 text-gray-700 cursor-not-allowed' : 'bg-gray-200 text-gray-800 hover:bg-gray-300'}`}
        >
          Record a Video
        </button>
      </div>
    </div>
  );
};

export default PhotoUpload;